import React from 'react';
import './LoadingSpinner.css';
import logo from './assets/img/TagandTrace_logo.png';  

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner">
        <img src={logo} alt="Logo" className="logo" />  
        <div className="spin"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
